<div
  class="modal-backdrop"
  [class.visible]="isVisible"
  (click)="onBackdropClick()">
</div>

<div
  [class]="'modal-container ' + getCssClass()"
  [class.visible]="isVisible">
  <ng-template #modalContent></ng-template>
</div>
